import { Typography } from '@vp/visage'
import classNames from 'classnames'
import { Link } from 'gatsby'
import * as React from 'react'
import { FiLink2 } from 'react-icons/fi'
import styleClasses from './widget-header.module.scss'

export type WidgetHeaderProps = {
  header?: GatsbyTypes.Maybe<GatsbyTypes.headingFragment>
}

type Typographies = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
type TypographyValues = 1 | 2 | 3 | 4 | 5 | 6

type TypeConfig = {
  headingSize: TypographyValues
  subTextComponent: Typographies
  classNames?: string
}
const typographyMapper: Record<Typographies, TypeConfig> = {
  h1: {
    headingSize: 1,
    subTextComponent: 'h3',
    classNames: 'mt-8 mb-4',
  },
  h2: {
    headingSize: 2,
    subTextComponent: 'h4',
    classNames: 'mt-8 mb-4',
  },
  h3: {
    headingSize: 3,
    subTextComponent: 'h5',
    classNames: 'mt-6 mb-3',
  },
  h4: {
    headingSize: 4,
    subTextComponent: 'h5',
    classNames: 'mt-6 mb-3',
  },
  h5: {
    headingSize: 5,
    subTextComponent: 'h6',
    classNames: 'mt-4 mb-2',
  },
  h6: {
    headingSize: 6,
    subTextComponent: 'h6',
    classNames: 'mt-3 mb-2',
  },
}

const WidgetHeader: React.FC<WidgetHeaderProps> = ({ header }) => {
  if (!header || !header.variant) return null
  const variantConfig: TypeConfig = typographyMapper[header?.variant as Typographies]
  if (!variantConfig) return null
  return (
    <>
      <Typography
        className={classNames(variantConfig.classNames, styleClasses.heading)}
        component={header.variant as Typographies}
        textSize={variantConfig.headingSize}
        id={header.slug || undefined}
      >
        {header.text}
        {!!header.slug && (
          <Link className={styleClasses.link} to={`#${header.slug}`}>
            <FiLink2 />
          </Link>
        )}
      </Typography>
      {header.subText ? (
        <Typography component={variantConfig.subTextComponent} className={styleClasses.subtext}>
          {header.subText}
        </Typography>
      ) : null}
      {header.abstract ? <p>{header.abstract}</p> : null}
    </>
  )
}

export default WidgetHeader
